import type { ReactElement } from "react"
import React from "react"
import _t from "@core/i18n"
import useBreakpoint from "@onestore/hel/dist/hooks/useBreakpoint"
import isServer from "~/lib/isServer"
import ProductSlider from "../../components/ProductsSlider"
import useLastViewedProducts from "../../hooks/useLastViewedProducts"

interface LastViewedProductsContainerProps {
  currentUrl: string
}

export default function LastViewedProductsContainer({
  currentUrl,
}: LastViewedProductsContainerProps): ReactElement<LastViewedProductsContainerProps> | null {
  const lastViewedProducts = useLastViewedProducts(currentUrl)
  const isSmallScreen = useBreakpoint("small", "medium")

  if (
    isSmallScreen ||
    isServer() ||
    !lastViewedProducts ||
    !lastViewedProducts.length
  ) {
    return null
  }

  return (
    <ProductSlider
      title={_t("marketplace.lastViewedProducts")}
      products={lastViewedProducts}
    />
  )
}
